export const branchNavigation = { replace: (url: string): void => location.replace(url) };

